module.exports = __webpack_public_path__ + "img/Unidad3-2.7e482072.png";